import { OperationEnum, OperationsMapper } from '../types';
import {
  useContainsOperation,
  useEndsWithOperation,
  useInListOperation,
  useMatchesOperation,
  useStartsWithOperation,
} from './operations';
import { ListStringOperationPayload, SingleStringOperationPayload } from './types';

export * from './operations';
export * from './types';

export const StringOperationsMapper: OperationsMapper = {
  [OperationEnum.StartsWith]: (value) => useStartsWithOperation(value as ListStringOperationPayload),
  [OperationEnum.EndsWith]: (value) => useEndsWithOperation(value as ListStringOperationPayload),
  [OperationEnum.Contains]: (value) => useContainsOperation(value as ListStringOperationPayload),
  [OperationEnum.InList]: (value) => useInListOperation(value as ListStringOperationPayload),
  [OperationEnum.Matches]: (value) => useMatchesOperation(value as SingleStringOperationPayload),
};
